<pdf-shy-button
  primaryToolbarId="primaryMoveUpButton"
  secondaryMenuId="secondaryMoveUpButton"
  [cssClass]="showMoveUpButton() | responsiveCSSClass: 'hiddenSmallView'"
  title="Move Page Up"
  l10nLabel="pdfjs-editor-movePageUp-button-label"
  [action]="movePageUp"
  [disabled]="disable()"
  image="<svg viewBox='0 0 24 24' height='20px' width='24px' aria-hidden='true'><path d='M12 1L8 5h8l-4-4z' fill='currentColor'></path><path d='M14 7l6 6v7a2 2 0 0 1-2 2v-3H6v3a2 2 0 0 1-2-2v-11a2 2 0 0 1 2-2h8m4 12v-5h-5v-5H6v10h12z' fill='currentColor'></path><path d='M6 21h12' stroke-dasharray='3,2' stroke-width='2' stroke='currentColor' fill='none'></path></svg>"
  [order]="460"
>
</pdf-shy-button>
